/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Panel, Button, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import TablePagerTDM from 'loracoms/TablePagerTDM';
import ShowIf from 'loracoms/ShowIf';
import LoadingTable from 'loracoms/LoadingTable';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import { updateTdmGateways } from 'loraactions/tdm';
import callAPI from '@/api/callAPI';
import { pageParams, updateMarks } from 'lorautils/pagerUtil';
import CreateModal from './CreateModal';
import ResetModal from './ResetModal';
import styles from '../styles.scss';

const kLimit = 10;
const kGatewayTdmLimit = 1000;
const kMarksKey = 'gatewayMarks';
const kRouteAction = ['POP', 'REPLACE'];

const propTypes = {
  intl: intlShape.isRequired,
  network: PropTypes.string.isRequired,
  routerAction: PropTypes.string.isRequired,
  updateTdmGateways: PropTypes.func.isRequired,
};

class Gateway extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      status: '',
      deleteNode: {},
      network: props.network,
    };
    this.marks = [];
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.gateway');
    this.callback = this.callback.bind(this);
    this.handlePaging = this.handlePaging.bind(this);
  }

  componentDidMount() {
    if (_.includes(kRouteAction, this.props.routerAction)) {
      this.marks = pageParams.getMarks(kMarksKey) || [];
      if (this.marks.length > 1) {
        this.mark = this.marks[this.marks.length - 2];
      }
    }
    this.loadGateways();
    this.loadGatewaysAll();
  }

  componentWillReceiveProps({ network }) {
    if (network !== this.props.network) {
      this.setState({ network });
    }
  }

  componentWillUnmount() {
    pageParams.setMarks(this.marks, kMarksKey);
  }

  loadGateways() {
    this.setState({ status: 'pending' });
    callAPI({
      endpoint: '/tdmng/gateways',
      query: { limit: kLimit, mark: this.mark },
    }).then(({ list, more, mark }) => {
      this.marks = updateMarks(this.marks, mark);
      this.setState({ list, more, mark: this.marks, status: 'success' });
    }).catch(() => {});
  }

  loadGatewaysAll() {
    callAPI({
      endpoint: '/tdmng/gateways',
      query: { mark: 0, limit: kGatewayTdmLimit },
    }).then((res) => {
      const data = res || {};
      this.props.updateTdmGateways(data);
    }).catch(() => {});
  }

  deleteGateway(deleteNode = {}) {
    callAPI({
      method: 'DELETE',
      endpoint: `/tdmng/gateways/${deleteNode.id}`,
    }).then(() => {
      this.resetMark();
      this.loadGateways();
      this.loadGatewaysAll();
      this.setState({ deleteNode });
    }).catch(() => {});
  }

  resetGateway(id) {
    this.setState({ resetId: id, showReset: true });
  }

  handlePaging(mark) {
    this.mark = mark;
    this.loadGateways();
  }

  resetMark() {
    this.mark = 0;
    this.marks = [];
    this.setState({ reset: new Date().valueOf() });
  }

  callback() {
    this.resetMark();
    this.loadGateways();
    this.loadGatewaysAll();
  }

  render() {
    const {
      list,
      status,
      network,
      deleteNode,
      mark = '',
      reset = 0,
      resetId,
      more = false,
      showCreate = false,
      showReset = false,
    } = this.state;
    let content = null;
    const thead = (
      <thead>
        <tr>
          <th>{this.intlMsg.msg('type')}</th>
          <th>{this.intlMsg.msg('gateway1')}</th>
          <th>{this.intlMsg.msg('mac1')}</th>
          <th>{this.intlMsg.msg('gateway2')}</th>
          <th>{this.intlMsg.msg('mac2')}</th>
          <th>{this.intlMsg.msg('penalty')}</th>
          <th>{this.intlMsg.msg('remark')}</th>
          <th>{this.intlMsg.msg('reset')}</th>
          <th>{this.intlMsg.msg('delete')}</th>
        </tr>
      </thead>
    );
    if (status === 'success') {
      content = (
        <Table className="aisz-table-light" striped>
          {thead}
          <tbody>
            {_.map(list, (l) => {
              const memo = l.memo ? JSON.parse(l.memo) : {};
              return (
                <tr key={l.id}>
                  <td>{l.mac2 ? this.intlMsg.msg('16channels') : this.intlMsg.msg('8channels')}</td>
                  <td>{memo.name1 || '--'}</td>
                  <td>
                    <Link to={`/network/tdm/gateway/${l.id}`}>
                      {normalizeDevEUI(l.id)}
                    </Link>
                  </td>
                  <td>{memo.name2 || '--'}</td>
                  <td>{l.mac2 ?
                    <Link to={`/network/tdm/gateway/${l.id}`}>
                      {normalizeDevEUI(l.mac2)}
                    </Link> : '--'}
                  </td>
                  <td className="text-center">{l.penalty}</td>
                  <td>{memo.remark}</td>
                  <td>
                    <a
                      onClick={() => this.resetGateway(l.id)}
                      className={styles.resetGateway}
                    >
                      <i className="fa fa-repeat" />
                    </a>
                  </td>
                  <td>
                    <a
                      className={styles.deleteBtn}
                      onClick={() => this.deleteGateway(l)}
                    >
                      <i className="halflings halflings-trash" />
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      );
    } else {
      content = (
        <LoadingTable
          className="aisz-table-light"
          striped
          bordered
          rows={1}
          cols={9}
        >
          {thead}
        </LoadingTable>
      );
    }

    const header = (
      <div>
        {this.intlMsg.msg('title')}
        <div className="pull-right">
          <Button
            bsStyle="aisz-success"
            disabled={!network}
            onClick={() => this.setState({ showCreate: true })}
            className={styles.addBtn}
          >
            <span className="glyphicons glyphicons-plus" aria-hidden="true" />&nbsp;
            {this.intlMsg.msg('add')}
          </Button>
        </div>
      </div>
    );
    return (
      <Panel bsStyle="aisz-white" header={header}>
        {content}
        <ShowIf if={status === 'success' && !list.length}>
          <div className={styles.noData}>{this.intlMsg.msg('nodata')}</div>
        </ShowIf>
        <ShowIf if={list.length > 0}>
          <div className={styles.pager}>
            <TablePagerTDM
              status={status}
              mark={mark}
              more={more}
              reset={reset}
              onPrev={this.handlePaging}
              onNext={this.handlePaging}
            />
          </div>
        </ShowIf>
        <CreateModal
          show={showCreate}
          deleteNode={deleteNode}
          network={network}
          onAdded={this.callback}
          onHide={() => this.setState({ showCreate: false })}
        />
        <ResetModal
          showModal={showReset}
          id={resetId}
          onCancel={() => this.setState({ showReset: false })}
        />
      </Panel>
    );
  }
}

Gateway.propTypes = propTypes;

const mapDispatchProps = ({
  updateTdmGateways,
});

export default connect(null, mapDispatchProps)(injectIntl(Gateway));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Gateway/index.jsx